import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const NotStenaTemplateDialogContainer = styled.div`
    display: flex;
    flex-direction:column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    & > h3 {
      font-size: 26px;
      margin: 7.5px;
    }
    & > p {
      margin: 0;
      color: #335B80;
    }

    & > img {
      width: 175px;
      height: 175px;
      margin: 15px;
    }

     & > button {
      padding:17.5px;
      border-radius:5px;
      margin: 45px 0px 15px 0px;
      border: 1px solid #335B80;
      color: #335B80;
      font-weight: 700;
      background-color: #DFE9F2;
      cursor: pointer;
    }

    & > a {
      margin: 0;
      text-decoration: underline;
      color: #335B80;
      cursor: pointer;
    }
`;

const NotStenaTemplateDialog = ({
  title,
  explanation,
  uploadNewFileTitle,
  continueText,
  onClickImportNewFileNotStenaTemplate,
  onClickContinueWithImportNotStenaTemplate,
}) => (
  <NotStenaTemplateDialogContainer
    className={[
      'not-stena-template-dialog',
    ].join(' ')}
  >
    <img src="/assets/images/varning.svg" alt="aaa" />
    <h3>{title}</h3>
    <p>{explanation}</p>
    <button onClick={() => onClickImportNewFileNotStenaTemplate()}>{uploadNewFileTitle}</button>
    <a role="button" tabIndex={0} onClick={() => onClickContinueWithImportNotStenaTemplate()}>{continueText}</a>
  </NotStenaTemplateDialogContainer>
);

NotStenaTemplateDialog.propTypes = {
  title: PropTypes.string,
  explanation: PropTypes.string,
  uploadNewFileTitle: PropTypes.string,
  continueText: PropTypes.string,
  onClickContinueWithImportNotStenaTemplate: PropTypes.func,
  onClickImportNewFileNotStenaTemplate: PropTypes.func,
};

export default NotStenaTemplateDialog;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/blocks/notStenaTemplateDialog.js